import { Portal } from '@mui/material';
import { FileCollectionT, ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement } from 'react';
import { PDFIcon, ExcelIcon, DocumentIcon } from '../../../../../icons/appIcons';
import { ObosX, ObosDownload } from '../../../../../icons/obos/obosIcons';
import { Modal } from '../../../../overlay';
import ObjectViewInterestForm from '../../Desktop/ObjectViewInterestForm/ObjectViewInterestForm';

type ObjectViewMobileInterestFormModalProps={
    showInterestForm: boolean;
    onClose: () => void;
    selectedObject?: ObjectContainerClientT;
    fileCollections?: FileCollectionT[];
};

const ObjectViewMobileInterestFormModal: React.FC<ObjectViewMobileInterestFormModalProps> = ({ onClose, showInterestForm, selectedObject }): ReactElement => {

    return (
        <>{showInterestForm && <Portal>
            <Modal
                className={'bv-object-view-mobile-floorplan-modal bv-ovm bv-ovm-if'}
                showModal={showInterestForm}
                modalPaperStyle={{ height: 'auto', minHeight: '30%' }}
                onBackdropClick={onClose}
            >
                <div className={'bv-objectview-close'} style={{ width: '3rem', height: '3rem', borderRadius: '1.5rem' }} onClick={onClose}>
                    <ObosX className={'bv-obos-x'}
                        style={{
                            width: '1.5rem',
                            height: '1.5rem',
                            padding: '0.75rem' }} />
                </div>
                <ObjectViewInterestForm
                    selectedObject={selectedObject} showInterestForm={showInterestForm} onClose={onClose}/>
            </Modal>
        </Portal>}</>
    );
};


export default ObjectViewMobileInterestFormModal;